var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1994_2185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1988 12.0195L23.5439 2.67406C24.1521 2.06618 24.1521 1.08332 23.5439 0.475441C22.936 -0.132439 21.9532 -0.132439 21.3453 0.475441L11.9999 9.82085L2.65474 0.475441C2.04658 -0.132439 1.064 -0.132439 0.456124 0.475441C-0.152041 1.08332 -0.152041 2.06618 0.456124 2.67406L9.80125 12.0195L0.456124 21.3649C-0.152041 21.9728 -0.152041 22.9556 0.456124 23.5635C0.759067 23.8667 1.15739 24.019 1.55543 24.019C1.95347 24.019 2.35151 23.8667 2.65474 23.5635L11.9999 14.2181L21.3453 23.5635C21.6485 23.8667 22.0465 24.019 22.4446 24.019C22.8426 24.019 23.2407 23.8667 23.5439 23.5635C24.1521 22.9556 24.1521 21.9728 23.5439 21.3649L14.1988 12.0195Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1994_2185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b91265a7d635e78f52f7eb96c1dcae16.svg";
export { ForwardRef as ReactComponent };